import { events } from './events.js';
function shallowEqualSteps(a, b) {
    if (a.length !== b.length)
        return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i].id !== b[i].id || a[i].target !== b[i].target)
            return false;
    }
    return true;
}
export function createTour(deps) {
    const state = {
        tourId: null,
        steps: [],
        index: -1,
        active: false,
        options: {},
        storage: deps?.storage,
    };
    function persist() {
        if (!state.active || !state.storage || !state.options.storageKey || !state.tourId)
            return;
        const base = `${state.options.storageKey}:${state.tourId}`;
        state.storage.set(`${base}:lastIndex`, String(state.index));
    }
    function restore(tourId, options) {
        if (!state.storage || !options?.storageKey)
            return undefined;
        const base = `${options.storageKey}:${tourId}`;
        const s = state.storage.get(`${base}:lastIndex`);
        const n = s != null ? Number(s) : NaN;
        return Number.isFinite(n) ? n : undefined;
    }
    function enterStep(idx) {
        state.index = idx;
        const step = state.steps[idx];
        if (step) {
            const ev = { type: 'step:enter', stepId: step.id, index: idx };
            events.emit(ev);
            state.onEvent?.(ev);
        }
        persist();
    }
    function leaveStep(idx, action) {
        const step = state.steps[idx];
        if (step) {
            const ev = {
                type: 'step:leave',
                stepId: step.id,
                index: idx,
                action,
            };
            events.emit(ev);
            state.onEvent?.(ev);
        }
    }
    const api = {
        start(tourId, steps, options) {
            if (state.active && state.tourId === tourId && shallowEqualSteps(state.steps, steps)) {
                return;
            }
            state.tourId = tourId;
            state.steps = steps.slice();
            state.active = true;
            state.options = options ?? {};
            state.storageKey = options?.storageKey;
            const ev = { type: 'start', tourId };
            events.emit(ev);
            state.onEvent?.(ev);
            const restored = restore(tourId, options);
            const startIndex = typeof restored === 'number' ? Math.max(0, Math.min(restored, steps.length - 1)) : 0;
            enterStep(startIndex);
        },
        stop(reason = 'skip') {
            if (!state.active)
                return;
            if (state.index >= 0)
                leaveStep(state.index, reason === 'skip' ? 'skip' : 'next');
            if (state.storage && state.options.storageKey && state.tourId) {
                const base = `${state.options.storageKey}:${state.tourId}`;
                state.storage.set(`${base}:lastIndex`, String(state.index));
                state.storage.set(`${base}:completed`, reason === 'finish' ? '1' : '0');
            }
            const tid = state.tourId ?? 'unknown';
            state.tourId = null;
            state.steps = [];
            state.index = -1;
            state.active = false;
            {
                const ev = { type: reason, tourId: tid };
                events.emit(ev);
                state.onEvent?.(ev);
            }
        },
        next() {
            if (!state.active)
                return;
            const i = state.index;
            leaveStep(i, 'next');
            const next = i + 1;
            if (next >= state.steps.length) {
                api.stop('finish');
            }
            else {
                enterStep(next);
            }
        },
        back() {
            if (!state.active)
                return;
            const i = state.index;
            leaveStep(i, 'back');
            const prev = Math.max(0, i - 1);
            enterStep(prev);
        },
        getState() {
            return state;
        },
        on(fn) {
            return events.on(fn);
        },
        configure(opts) {
            if (opts.storage)
                state.storage = opts.storage;
            if (opts.onEvent)
                state.onEvent = opts.onEvent;
        },
    };
    return api;
}
export const tour = createTour();
//# sourceMappingURL=core.js.map